var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardBlockedLtr = function SvgCreditCardBlockedLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.343 61.437a.77.77 0 0 1-.764-.76v-26.65l60.422-.113A28 28 0 0 1 77 31.978v-9.654C77 19.388 74.603 17 71.657 17H5.343C2.397 17 0 19.388 0 22.324v38.352C0 63.612 2.397 66 5.343 66h42.723a28 28 0 0 1-.64-4.563zm-.764-39.113c0-.412.35-.76.764-.76h66.314c.414 0 .764.348.764.76v4.653l-67.842.125zM80.372 55h1.837c.988 0 1.791.812 1.791 1.81v9.38c0 .998-.803 1.81-1.791 1.81H68.791A1.803 1.803 0 0 1 67 66.19v-9.38c0-.998.804-1.81 1.791-1.81h1.988v-3.153c0-2.672 2.151-4.847 4.796-4.847s4.797 2.175 4.797 4.847zm-4.797-6.4c-1.772 0-3.213 1.457-3.213 3.247V55h6.427v-3.153c0-1.79-1.442-3.247-3.214-3.247",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M76 37c-12.682 0-23 10.318-23 23s10.318 23 23 23 23-10.317 23-23-10.318-23-23-23m0 41.575c-10.242 0-18.575-8.333-18.575-18.575S65.758 41.425 76 41.425 94.575 49.758 94.575 60 86.242 78.575 76 78.575",
    clipRule: "evenodd"
  })));
};
export default SvgCreditCardBlockedLtr;